import type { DictationTextFieldOptions } from '@features/dictation/components/DictationTextField';

/**
 * Vocabulary the recognizer should spell exactly when a clinician dictates an
 * instruction to the note assistant. Fixed strings only: never note or
 * patient content.
 */
export const NOTE_CHAT_DICTATION_KEYTERMS = [
  'HPI',
  'history of present illness',
  'mental status exam',
  'MSE',
  'assessment',
  'plan',
  'medications',
  'diagnosis',
  'ICD-10',
  'CPT',
  'SOAP',
  'chief complaint',
  'review of systems',
  'risk assessment',
  'safety plan',
  'psychoeducation',
  'follow-up',
  'template',
  'section',
  'bold',
  'bullet points',
];

export const NOTE_CHAT_DICTATION: DictationTextFieldOptions = {
  surface: 'note_chat',
  keyterms: NOTE_CHAT_DICTATION_KEYTERMS,
  prompt:
    'A clinician tells an assistant how to change a clinical note: which section to edit, what to shorten, add, reword, or format.',
};
